import React from 'react';
import {FormattedHTMLMessage, FormattedDate} from 'react-intl';
import './accept-invite-modal.less';

const MockHeadline = ({noPropertiesText, propertiesText, unitsCount, stay}) => {
    if (stay && stay.dateRange && stay.dateRange.arrival && stay.dateRange.departure) {
        return (
            <div>
                <FormattedDate value={stay.dateRange.arrival} month="long" day="2-digit" timeZone="UTC" />
                {' - '}
                <FormattedDate value={stay.dateRange.departure} month="long" day="2-digit" timeZone="UTC" />
            </div>
        );
    }
    if (unitsCount && unitsCount > 0) {
        return <FormattedHTMLMessage id="TB headline" defaultMessage={propertiesText} values={{COUNT: unitsCount}} />;
    }
    return noPropertiesText;
};

const BgImage = ({tripBoard, imageIndex, className}) => {
    const thisUrl =
        (tripBoard &&
            tripBoard.listings &&
            tripBoard.listings[imageIndex] &&
            tripBoard.listings[imageIndex].mobileThumbnailUrl) ||
        '';

    return <div className={className} style={{backgroundImage: `url(${thisUrl})`}} />;
};

const PreviewInviteModal = ({noPropertiesText, propertiesText, unitsCount, stay, tripBoard}) => (
    <div className="accept-invite-modal__preview">
        <div className="accept-invite-modal__modal-bg" />
        <div className="accept-invite-modal__listing-preview">
            <div className="header text-emphasis">
                <MockHeadline {...{noPropertiesText, propertiesText, unitsCount, stay}} />
            </div>
            <BgImage className="left-content" imageIndex={0} tripBoard={tripBoard} />
            <div className="right-content">
                <BgImage className="right-content__top" imageIndex={1} tripBoard={tripBoard} />
                <BgImage className="right-content__bottom" imageIndex={2} tripBoard={tripBoard} />
            </div>
        </div>
    </div>
);

export default PreviewInviteModal;



// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/components/preview-invite-modal.js